module.exports = __webpack_public_path__ + "img/dostavka_ot_2kh_chasov.9f5fe9f.webp";